import React, { useEffect, useState } from 'react';
import ProjectEvaluationsection1 from './ProjectEvaluationsection1';
import ProjectEvaluationSection2 from './ProjectEvaluationSection2';
import axios from "../../../../utils/fvAxios";
import apiinfo from "../../../../utils/base-uri.json";
import ProjectEvaluationSection3 from './ProjectEvaluationSection3';
import { Button } from '@mui/material';
import { useTranslation } from "react-i18next";
import "../../../../Localization/i18n";

export default function ProjectEvalution({ ReviewInputId, BackEvaluationList }) {
  const [vendorReviewInput, setVendorReviewInput] = useState([]);
  const [vendorReviewInputRadio, setVendorReviewInputradio] = useState([]);
  const [vendorReviewInputSection3, setVendorReviewInputSection3] = useState([]);

  useEffect(() => {
    VendorReviewInput();
  }, []);

  const { t } = useTranslation();
  const params = new URLSearchParams(window.location.search);
  const PQID = params.get("pqid");

  async function VendorReviewInput() {
    const res = await axios.get("/Prequalification/GetVendorReviewInput?pqId=" + PQID + "&vendorReviewInputId=" + ReviewInputId);
    setVendorReviewInput(res?.data?.data);
    setVendorReviewInputradio(res?.data?.data?.vendorReviews);
    setVendorReviewInputSection3(res?.data?.data?.localVendorReviewSection)
  }
  return (
    <>
      {/* Section1 */}
      <ProjectEvaluationsection1 data={vendorReviewInput} />
      <ProjectEvaluationSection2 data={vendorReviewInputRadio} />
      <ProjectEvaluationSection3 data={vendorReviewInputSection3} />

      <Button variant="contained"
        //href={"/vendordetails?pqid=" + PQID}
        onClick={BackEvaluationList}
        sx={{ textTransform: "capitalize", padding: "15px", marginTop: "5px",float: "right" }}> {t("ProjectEvalution.label3")}</Button> {/*onClick={() => props.RatingTypeChange((p) => !p, '')}*/}
    </>
  )
}
